<template>
  <div class="flex flex-between step-item">
    <div>
      <p class="step_user--owner">{{ user.is_owner ? 'Is Owner' : 'Not An Owner' }}</p>
      <p class="step_user--label">{{ user.email_address }}</p>
    </div>

    <button-icon @click="deleteUser" icon="delete"/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "StepItemUser",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteUser() {
      this.$store.commit('onboarding/deleteUser', this.user);
    },
  },
})
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.step-item {
  max-width: 440px;
  padding: 8px;

  &:nth-of-type(odd) {
    background-color: $background;
  }
}

.step_user {
  &--owner {
    margin-bottom: 4px;
    font-size: 0.75rem;
  }
}
</style>
